// import React, { Suspense, useState, useEffect } from 'react';
import React, { Suspense, useState } from 'react';
import { CssBaseline } from '@material-ui/core';
import { MuiPickersUtilsProvider } from '@material-ui/pickers';
import { QueryClient, QueryClientProvider } from 'react-query';
import { ReactQueryDevtools } from 'react-query/devtools';
import { DndProvider } from 'react-dnd';
import { HTML5Backend } from 'react-dnd-html5-backend';
import DateFnsUtils from '@date-io/date-fns';
import Routes from './Routes';
import { ThemeProvider } from './utils/theme';
import { PermissionContext } from './contexts/PermissionContext';
// import { AuthContext } from './contexts/AuthContext';
import { AuthProviderWrapper } from './utils/auth';
// import { AuthProvider, MsalRedirect } from './utils/auth';
// import { VerticalProvider } from './utils/auth/VerticalProvider';
// import { SupportBUProvider } from './utils/auth/SupportBUProvider';
import { GqlApiProvider } from './api/client';
import { AbilityContext, defineAbility } from './permissions/ability';
import { storeInitialPath } from './utils/redirect/LocalRedirectUrlStorage';
import { storeInitialTenant } from './utils/storage/UnitySessionStorage';

const queryClient = new QueryClient();

let App = () => {
  const ability = defineAbility();
  // const [isAuth, setIsAuth] = useState(null);
  const [permissionOptions, setPermissionOptions] = useState({
    level: 'silver',
    option: true,
    mapOption: true,
    mapEditOption: true,
    mapViewOption: true,
  });
  storeInitialPath();
  storeInitialTenant();

  const changePermission = permission => {
    setPermissionOptions(permission);
  };

  // useEffect(() => {
  //   setIsAuth(true);
  // }, []);

  return (
    // <BrandingContext branding={whitelabelBranding} />,
    <Suspense fallback="loading">
      <DndProvider backend={HTML5Backend}>
        <ThemeProvider>
          <AuthProviderWrapper>
            <MuiPickersUtilsProvider utils={DateFnsUtils}>
              <AbilityContext.Provider value={ability}>
                <PermissionContext.Provider value={permissionOptions}>
                  <GqlApiProvider>
                    {/* <AuthContext.Provider value={{ isAuth, setIsAuth }}> */}
                    <CssBaseline />
                    <QueryClientProvider client={queryClient}>
                      <Routes />
                      <ReactQueryDevtools initialIsOpen={false} />
                    </QueryClientProvider>
                    {/* </AuthContext.Provider> */}
                  </GqlApiProvider>
                </PermissionContext.Provider>
              </AbilityContext.Provider>
            </MuiPickersUtilsProvider>
          </AuthProviderWrapper>
        </ThemeProvider>
      </DndProvider>
    </Suspense>
  );
};

export default App;
